// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function TMPUIKIT____CssGrid__Jsx3$Grid(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let cls = TailwindMerge.twMerge([
    "grid grid-cols-12 gap-4 auto-rows-[minmax(20px,auto)]",
    className
  ]);
  return JsxRuntime.jsx("div", {
    children: Stdlib_Option.getOr(props.children, null),
    className: cls
  });
}

let Grid = {
  make: TMPUIKIT____CssGrid__Jsx3$Grid
};

function spanBase(w) {
  switch (w) {
    case 1 :
      return "col-span-1";
    case 2 :
      return "col-span-2";
    case 3 :
      return "col-span-3";
    case 4 :
      return "col-span-4";
    case 6 :
      return "col-span-6";
    case 8 :
      return "col-span-8";
    default:
      return "col-span-12";
  }
}

function spanSm(w) {
  switch (w) {
    case 1 :
      return "sm:col-span-1";
    case 2 :
      return "sm:col-span-2";
    case 3 :
      return "sm:col-span-3";
    case 4 :
      return "sm:col-span-4";
    case 5 :
      return "sm:col-span-5";
    case 6 :
      return "sm:col-span-6";
    case 7 :
      return "sm:col-span-7";
    case 8 :
      return "sm:col-span-8";
    case 12 :
      return "sm:col-span-12";
    default:
      return "";
  }
}

function spanMd(w) {
  switch (w) {
    case 1 :
      return "md:col-span-1";
    case 2 :
      return "md:col-span-2";
    case 3 :
      return "md:col-span-3";
    case 4 :
      return "md:col-span-4";
    case 5 :
      return "md:col-span-5";
    case 6 :
      return "md:col-span-6";
    case 8 :
      return "md:col-span-8";
    case 12 :
      return "md:col-span-12";
    default:
      return "";
  }
}

function spanLg(w) {
  switch (w) {
    case 1 :
      return "lg:col-span-1";
    case 2 :
      return "lg:col-span-2";
    case 3 :
      return "lg:col-span-3";
    case 4 :
      return "lg:col-span-4";
    case 6 :
      return "lg:col-span-6";
    case 7 :
      return "lg:col-span-7";
    case 8 :
      return "lg:col-span-8";
    case 9 :
      return "lg:col-span-9";
    case 12 :
      return "lg:col-span-12";
    default:
      return "";
  }
}

function spanXl(w) {
  switch (w) {
    case 1 :
      return "xl:col-span-1";
    case 2 :
      return "xl:col-span-2";
    case 3 :
      return "xl:col-span-3";
    case 4 :
      return "xl:col-span-4";
    case 5 :
      return "xl:col-span-5";
    case 6 :
      return "xl:col-span-6";
    case 7 :
      return "xl:col-span-7";
    case 8 :
      return "xl:col-span-8";
    case 12 :
      return "xl:col-span-12";
    default:
      return "";
  }
}

function TMPUIKIT____CssGrid__Jsx3$Cell(props) {
  let __children = props.children;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let children = __children !== undefined ? __children : null;
  let classes = [
    "min-w-0",
    Stdlib_Option.getOr(Stdlib_Option.map(props.width, spanBase), ""),
    Stdlib_Option.getOr(Stdlib_Option.map(props.widthSm, spanSm), ""),
    Stdlib_Option.getOr(Stdlib_Option.map(props.widthMd, spanMd), ""),
    Stdlib_Option.getOr(Stdlib_Option.map(props.widthLg, spanLg), ""),
    Stdlib_Option.getOr(Stdlib_Option.map(props.widthXl, spanXl), ""),
    className
  ];
  return JsxRuntime.jsx("div", {
    children: children,
    className: TailwindMerge.twMerge(classes)
  });
}

let Cell = {
  spanBase: spanBase,
  spanSm: spanSm,
  spanMd: spanMd,
  spanLg: spanLg,
  spanXl: spanXl,
  make: TMPUIKIT____CssGrid__Jsx3$Cell
};

exports.Grid = Grid;
exports.Cell = Cell;
/* tailwind-merge Not a pure module */
